import { SELECT_ORGANIZATION } from "../../constants.js";
import {Organization} from "../../../models/sso";
import {CanonicalOrganization} from "../../../models/canonical";

export const selectOrganization = (organization) => {
    Organization.byId.get(organization.id) || new Organization(organization);
    CanonicalOrganization.byId.get(organization.id) || new CanonicalOrganization(organization);
    return dispatch => {
        return dispatch({
            type: SELECT_ORGANIZATION,
            organization: organization
        });
    };
};


